import React from 'react';
import {MdOutlineCorporateFare} from 'react-icons/md';
import './ObjectIconDisplay.css';
import { usePermissions } from '../../hooks/usePermissions';
import classnames from 'classnames';


// eslint-disable-next-line no-unused-vars
export default function DetailViewerHeader({icon = <MdOutlineCorporateFare />, title, subtitle, openHistoryLogHandler,buttons}) {
	const { canSee, canEdit, canCreate, canDelete } = usePermissions();

	/**
	 * Check if button should be enabled based on its type
	 * @param {string} type - Button type: 'create', 'see', 'edit', 'delete'
	 * @returns {boolean}
	 */
	const hasPermission = (type) => {
		if (!type) return true; // If no type specified, allow by default for backward compatibility
		switch (type) {
		case 'create':
			return canCreate();
		case 'see':
			return canSee();
		case 'edit':
			return canEdit();
		case 'delete':
			return canDelete();
		default:
			return true;
		}
	};

	return (
		<div className='detail-viewer-header-wrapper'>
			<div className='object-icon-display'>
				<div className='d-flex w-auto'>
					<div className='icon'>{icon}</div>
					<div className='caption-display'>
						<span className='caption-text'>{title}</span>
						{subtitle && <span className='caption-subtitle'>{subtitle}</span>}
					</div>
				</div>
				{
					openHistoryLogHandler && 
                <div className="history-log text-start w-100" onClick={openHistoryLogHandler}>Historial de cambios</div>
				}
			</div>
			<div className="button-row">
				{
					buttons && buttons.filter(b => !b.hide && (!b.type || hasPermission(b.type))).map((b, index) => {
						return (
							<button
								key={index}
								className={classnames('header-button', 'ms-1')}
								onClick={b.onClick}
							>
								{b.label}
							</button>
						);
					})
				}
			</div>
		</div>
	);
}